import React, { useState } from "react";
import { Buttons } from "bnb-ui/dist";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";

export interface PropsOut {
  history?: any;
  classes?: any;
  fullScreen?: any;
  realizarLogout: Function;
}

export default function Out(props: PropsOut) {
  const [open, setOpen] = useState(false);

  function handleOut() {
    setOpen(false);
    props.realizarLogout();
  }

  return (
    <div>
      <Buttons onClick={() => setOpen(true)}>Sair</Buttons>
      <Dialog
        fullScreen={props.fullScreen}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Sair da aplicação?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que deseja sair da aplicação?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => setOpen(false)}>
            Cancelar
          </Button>
          <Button color="secondary" onClick={() => handleOut()} autoFocus>
            Sair
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
